const CLIENT_KEY = "fv_client_id";
const NICK_KEY = "fv_nick";

export const getClientId = () => {
  let id = localStorage.getItem(CLIENT_KEY);
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/-/g, "").slice(0, 32);
    localStorage.setItem(CLIENT_KEY, id);
  }
  return id;
};

export const getNick = () => localStorage.getItem(NICK_KEY) || "";
export const setNick = (n) => localStorage.setItem(NICK_KEY, n.trim().slice(0, 24));

export const saveHostKey = (code, key) => sessionStorage.setItem(`fv_party_host_${code}`, key);
export const getHostKey = (code) => sessionStorage.getItem(`fv_party_host_${code}`);

export const normalizeCode = (raw) => {
  const s = (raw || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  const body = s.startsWith("FEDE") ? s.slice(4) : s;
  return body ? `FEDE-${body.slice(0, 4)}` : "";
};
